function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback } from 'react';
import { flexRender } from '@tanstack/react-table';
import { getDisableHighlightOnMouseDown, getMultiRowRangeSelection } from './getMultiRowRangeSelection';
import { DEFAULT_TABLE_SIZE } from '../consts';
export default (_ref => {
  let {
    table,
    tableSize = DEFAULT_TABLE_SIZE,
    enableMultiRowRangeSelection = false,
    enableFullRowClick = true
  } = _ref;
  const {
    columnSizingInfo
  } = table.getState();
  const selectedRows = table.getSelectedRowModel().rows;
  const allRows = table.getRowModel().rows;
  const {
    setRowSelection
  } = table;
  const getTableHeaderGroupProps = useCallback(_headerGroup => ({
    tableSize
  }), [tableSize]);
  const getTableHeaderProps = useCallback(header => ({
    tableSize,
    colSpan: header.colSpan,
    size: header.getSize(),
    isPlaceholder: header.isPlaceholder,
    hasSubHeaders: header.subHeaders.length > 0,
    canResize: header.column.getCanResize(),
    isSorted: header.column.getIsSorted(),
    canSort: header.column.getCanSort(),
    toggleSort: header.column.getToggleSortingHandler(),
    isResizingAnyColumn: !!columnSizingInfo.isResizingColumn,
    isResizingColumn: header.column.getIsResizing(),
    handleResize: header.getResizeHandler(),
    renderValue: () => flexRender(header.column.columnDef.header, _objectSpread({
      tableSize
    }, header.getContext()))
  }), [tableSize, columnSizingInfo]);
  const getTableRowProps = useCallback(row => ({
    tableSize,
    canSelect: enableFullRowClick && row.getCanSelect(),
    toggleSelected: (val, e) => {
      const selectValue = typeof val !== 'undefined' ? val : !row.getIsSelected();
      if (enableMultiRowRangeSelection && e !== null && e !== void 0 && e.shiftKey && selectedRows.length && selectValue) {
        setRowSelection(old => _objectSpread(_objectSpread({}, old), getMultiRowRangeSelection(row, selectedRows, allRows)));
      } else {
        var _row$toggleSelected;
        (_row$toggleSelected = row.toggleSelected) === null || _row$toggleSelected === void 0 ? void 0 : _row$toggleSelected.call(row, val);
      }
    },
    isSelected: row.getIsSelected(),
    isHighlightable: row.getCanSelect(),
    onMouseDown: getDisableHighlightOnMouseDown({
      enableMultiRowRangeSelection,
      selectedRows
    })
  }), [tableSize, selectedRows, allRows, setRowSelection, enableMultiRowRangeSelection, enableFullRowClick]);
  const getTableCellProps = useCallback(cell => ({
    tableSize,
    size: cell.column.getSize(),
    isResizing: cell.column.getIsResizing(),
    children: flexRender(cell.column.columnDef.cell, _objectSpread({
      tableSize
    }, cell.getContext()))
  }), [tableSize]);
  return {
    getTableHeaderGroupProps,
    getTableHeaderProps,
    getTableRowProps,
    getTableCellProps
  };
});
//# sourceMappingURL=useTable.js.map